import { useEffect, useState } from "react";
import "./Alert.scss";
import { ReactSVG } from "react-svg";

interface AlertProps {
    page: string;
    message: string;
    type: string;
    onClose: () => void;
}

export default function Alert({ page, message, type ,onClose}: Readonly<AlertProps>) {
    const [show, setShow] = useState(true);
    const [statusCode, setStatusCode] = useState<string>("");    const [errors, setErrors] = useState<string>("");
    const [showOriginalErrorMessage, setShowOriginalErrorMessage] = useState(false);
    // Extract status code and errors from message
    const extractErrorMessageDetails = (message: string): { statusCode: string, errors: string } => {
        // Using a more specific pattern for status code
        const statusCodeRegex = /Status Code: ([1-9]\d{0,2})/;
        // Limit the error message length and avoid using .* pattern
        const errorsRegex = /Errors: ([^\n]{0,2000})/;
        // Use atomic group with possessive quantifier emulation for bracket content
        const errorBodyRegex = /\[((?=(([^[\]]{1,1000}))\3))\]/;

        const statusCodeMatch = statusCodeRegex.exec(message);
        if (!statusCodeMatch || (statusCodeMatch[1] !== '400' && statusCodeMatch[1] !== '500')) {
            return originalErrorMessage();
        }

        const errorsMatch = errorsRegex.exec(message);
        if (!errorsMatch) {
            return originalErrorMessage();
        }

        const errorBodyMatch = errorBodyRegex.exec(errorsMatch[1]);
        if (!errorBodyMatch) {
            return originalErrorMessage();
        }

        return { statusCode: statusCodeMatch[1], errors: errorBodyMatch[1] };
    };

    const originalErrorMessage = ():{ statusCode: string, errors: string } => {
        setShowOriginalErrorMessage(true);
        return { statusCode: "", errors: message };
    };

    const checkMessageType = (message: string): void => {
        if (type === 'error') {
            const { statusCode, errors } = extractErrorMessageDetails(message);
            setStatusCode(statusCode);
            setErrors(errors);
        }
    }
    const handleClick = () => {
        setShow(false);
        onClose();
    };

    useEffect(() => {
        checkMessageType(message);
    }, [message, type]);

    const msg = () => {
        return (
            <auro-alert className="AlertHeader alert-bottom" type={type}>
            <div className="AlertContent">
              <div className="AlertBody">
                <div className="AlertHeaderContent">
                  <div>{page}</div>
                  <div className="AlertCloseIcon" role='button' aria-label='x-sm' tabIndex={0} onClick={handleClick} onKeyDown={(e) => { if (e.key === 'Enter') {  return} }}>
                    <ReactSVG src='https://cdn.jsdelivr.net/npm/@alaskaairux/icons@latest/dist/icons/interface/x-sm.svg' />
                  </div>
                </div>
                        {type === 'error' ? (
                  
                            <table className="error-table">
                                <tbody>
                                    {!showOriginalErrorMessage && (
                                        <tr>
                                            <td className="label">Status Code:</td>
                                            <td className="value">{statusCode}</td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td className="label">Errors:</td>
                                        <td className="value">{errors}</td>
                                    </tr>
                                </tbody>
                            </table>
            
                ) : (
                  <div className="message">{message}</div>
                )}
                    </div>
                    
                </div>
            </auro-alert>
        )
    }

    // If show is false the component will return null and stop here
    if (!show) {
        return null;
    }

    return (
        <div>
            {msg()}
        </div>
    )
}